async function loadStyle(resource, parentNode) {
  return new Promise((resolve, reject) => {
    const style = document.createElement("link");
    style.rel = "stylesheet";
    style.type = "text/css";
    style.href = resource;
    style.onload = () => resolve();
    style.onerror = () => reject();
    parentNode.appendChild(style);
  });
}
async function loadScript(resource, parentNode) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = resource;
    s.onload = () => resolve();
    s.onerror = () => reject();
    parentNode.appendChild(s);
  });
}
export {
  loadScript,
  loadStyle
};
//# sourceMappingURL=loadResource.js.map
